export const EnglishFont = 'Roboto'
